




















































































import {
  apiShoppingCartAddOrSub,
  apiShoppingCartList,
  apiShoppingCartRemove,
} from '@/api'
import { asRequiredDeep } from 'vtils'
import { computed } from '@vue/composition-api'
import {
  defineClassComponent,
  useActivated,
  useApiPlus,
  useHandler,
  useMessenger,
  useNewRoute,
} from '@/hooks'
import { instantDeliveryBus } from '../bus'
import { submit } from '@/utils'

export default defineClassComponent<{
  value: boolean
  martId: string
}>(
  {
    props: ['value', 'martId'],
  },
  ({ props, ctx }) =>
    class {
      constructor() {
        useNewRoute(this.visible)

        useActivated(() =>
          instantDeliveryBus.on('refreshCart', () => {
            this.apiData.refresh()
          }),
        )
      }

      visible = useMessenger(
        () => props.value,
        visible => ctx.$emit('input', visible),
      )

      loading = computed(() => this.apiData.loading)

      apiData = useApiPlus({
        cartData: () =>
          apiShoppingCartList(
            {},
            {
              businessChannel: props.martId,
            },
          ).then(asRequiredDeep),
      })

      cartData = computed(() => this.apiData.data.cartData.validList)

      handleServiceClick = useHandler<'清空购物车' | '更新数量'>({
        清空购物车: () => {
          submit(async $ => {
            $.start('清空中...')
            await apiShoppingCartRemove(
              {
                idList: this.cartData.value.map(item => item.id),
              },
              {
                businessChannel: props.martId,
              },
            )
            instantDeliveryBus.emit('refreshCart')
            await $.success('清空成功')
          })
        },
        更新数量: async (id: string, count: number) => {
          if (count <= 0) {
            await apiShoppingCartRemove(
              {
                idList: [id],
              },
              {
                businessChannel: props.martId,
              },
            )
          } else {
            await apiShoppingCartAddOrSub(
              {
                id: id,
                quantity: count,
              },
              {
                businessChannel: props.martId,
              },
            )
          }
          instantDeliveryBus.emit('refreshCart')
        },
      })
    },
)
